// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aca9af1e","553":"1dc5f5da","977":"c35651a6"}[chunkId] + ".chunk.js";
};